import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var PackageOutline = function PackageOutline(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.44531 18.1895L11.1797 22.5059C11.7168 22.8086 12.2637 22.8086 12.8008 22.5059L20.5352 18.1895C21.4824 17.6621 21.9512 17.1152 21.9512 15.7383V7.81836C21.9512 6.7832 21.5605 6.12891 20.6816 5.63086L13.8164 1.7832C12.6152 1.10938 11.375 1.10938 10.1641 1.7832L3.29883 5.63086C2.42969 6.12891 2.03906 6.7832 2.03906 7.81836V15.7383C2.03906 17.1152 2.50781 17.6621 3.44531 18.1895ZM16.5703 8.38477L9.35352 4.35156L10.9551 3.45312C11.6582 3.05273 12.3223 3.04297 13.0352 3.45312L19.1875 6.91992L16.5703 8.38477ZM11.9902 10.9434L4.80273 6.91992L7.49805 5.38672L14.7051 9.41992L11.9902 10.9434ZM4.51953 16.6758C3.98242 16.373 3.79688 16.0703 3.79688 15.5527V8.46289L11.0723 12.5645V20.377L4.51953 16.6758ZM19.4707 16.6758L12.9082 20.377V12.5645L20.1836 8.46289V15.5527C20.1836 16.0703 19.998 16.373 19.4707 16.6758Z"
  })));
};

PackageOutline.displayName = 'PackageOutline';
export default PackageOutline;